/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetDataConnectionsForHomePageSidebarQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetDataConnectionsForHomePageSidebarQuery = {
  readonly __typename: "Query";
  readonly orgDataConnections: ReadonlyArray<{
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionType: c.DataConnectionType;
    readonly isMultiDatabase: boolean;
  }>;
};

export const GetDataConnectionsForHomePageSidebarDocument = /*#__PURE__*/ gql`
  query GetDataConnectionsForHomePageSidebar($orgId: OrgId!) {
    orgDataConnections(orgId: $orgId, importable: true) {
      id
      connectionType
      isMultiDatabase
    }
  }
`;

/**
 * __useGetDataConnectionsForHomePageSidebarQuery__
 *
 * To run a query within a React component, call `useGetDataConnectionsForHomePageSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataConnectionsForHomePageSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataConnectionsForHomePageSidebarQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetDataConnectionsForHomePageSidebarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  > &
    (
      | {
          variables: GetDataConnectionsForHomePageSidebarQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  >(GetDataConnectionsForHomePageSidebarDocument, options);
}
export function useGetDataConnectionsForHomePageSidebarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  >(GetDataConnectionsForHomePageSidebarDocument, options);
}
export function useGetDataConnectionsForHomePageSidebarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  >(GetDataConnectionsForHomePageSidebarDocument, options);
}
export type GetDataConnectionsForHomePageSidebarQueryHookResult = ReturnType<
  typeof useGetDataConnectionsForHomePageSidebarQuery
>;
export type GetDataConnectionsForHomePageSidebarLazyQueryHookResult =
  ReturnType<typeof useGetDataConnectionsForHomePageSidebarLazyQuery>;
export type GetDataConnectionsForHomePageSidebarSuspenseQueryHookResult =
  ReturnType<typeof useGetDataConnectionsForHomePageSidebarSuspenseQuery>;
export type GetDataConnectionsForHomePageSidebarQueryResult =
  Apollo.QueryResult<
    GetDataConnectionsForHomePageSidebarQuery,
    GetDataConnectionsForHomePageSidebarQueryVariables
  >;
